import { intervalText, intervalTypeLabel, type IntervalFields } from '@/lib/lab/labDisplay';

/** Shared reference cell: IntervalText + limits, then TypeOfInterval (R 3.7 / M 3.14). */
export function LabReferenceInterval(row: IntervalFields) {
  const text = intervalText(row);
  const typeLabel = intervalTypeLabel(row.reference_interval_type);
  return (
    <>
      {text || '—'}
      {typeLabel ? <div className="text-xs text-ds-muted">{typeLabel}</div> : null}
    </>
  );
}
